import { createSlice } from '@reduxjs/toolkit';

import type { Operators } from './types';

export const slice = createSlice({
    initialState: {
        operators: undefined as Operators | undefined
    },

    name: 'useOperators',

    reducers: {
        operators: (state, action) => {
            state.operators = action.payload;
        }
    }
});

export default slice.reducer;
